import flattenDeep from 'lodash-es/flatMapDeep';
import isArray from 'lodash-es/isArray';
import isDate from 'lodash-es/isDate';
import isObject from 'lodash-es/isObject';
import sortBy from 'lodash-es/sortBy';
import transform from 'lodash-es/transform';
import { Observable } from 'rxjs';

const queryCache = new Map<string, Observable<any>>();

export type ObservableMethod = (...args: any[]) => Observable<any>;

function serializeDeep(arg: any): string[] {
	if (isArray(arg)) {
		return sortBy(flattenDeep(arg.map((a) => serializeDeep(a))));
	} else if (isDate(arg)) {
		return [String((arg as Date).getTime())];
	} else if (isObject(arg)) {
		return sortBy(
			transform(
				arg as any,
				(result, value, key) =>
					serializeDeep(value).forEach((val) => result.push(key + ':' + val)),
				[]
			)
		);
	} else {
		return [String(arg)];
	}
}

export function CacheObservable() {
	return function (
		target: any,
		propertyKey: string,
		descriptor: TypedPropertyDescriptor<ObservableMethod>
	) {
		const method = descriptor.value;

		descriptor.value = function (...args: any[]) {
			const key =
				target.constructor.name +
				'|' +
				propertyKey +
				'|' +
				serializeDeep(args).join('|');

			if (!queryCache.has(key)) {
				queryCache.set(key, method.apply(this, args));
			}

			return queryCache.get(key);
		};

		return descriptor;
	};
}
